import clsx from 'clsx';

import { twMerge } from './twMerge';

export const cn = (...args: Parameters<typeof clsx>): string => {
  return twMerge(clsx(...args));
};
